var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCareHistoryStdDiagnosisVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 25
    },
    viewBox: "0 0 28 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.257 25a4.26 4.26 0 0 0 3.012-1.241L22.028 8.993l1.892-.219a1.217 1.217 0 0 0 .721-2.068L18.295.359a1.217 1.217 0 0 0-2.072.718l-.22 1.892L1.246 17.731A4.26 4.26 0 0 0 4.257 25ZM18.024 4.393c.147-.152.252-.34.304-.544l2.812 2.81a1.217 1.217 0 0 0-.545.305l-2.738 2.738h-5.173l5.34-5.309Zm-15.06 15.06 7.302-7.301h5.172l-9.891 9.882a1.825 1.825 0 0 1-2.58-2.583l-.003.003ZM24.298 12.355a1.215 1.215 0 0 0-1.722 0l-2.07 2.07a4.144 4.144 0 0 0 0 5.86 4.146 4.146 0 0 0 5.937.078 4.144 4.144 0 0 0-.077-5.936l-2.068-2.072Zm.347 6.207a1.71 1.71 0 0 1-2.916-1.208c0-.453.18-.887.5-1.208l1.217-1.217 1.217 1.217a1.71 1.71 0 0 1-.015 2.42l-.003-.004Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareHistoryStdDiagnosisVisit);
export default __webpack_public_path__ + "static/media/icon_care_history_std_diagnosis_visit.2fae02463d548ce674430dd75b4762fa.svg";
export { ForwardRef as ReactComponent };